import { BREAKPOINTS, isNarrowView } from "../utilities/index.js";

(function () {
  "use strict";

  class Symbol {
    constructor(wrap) {
      this.wrap = wrap;
      this.img = this.wrap.querySelector("img");

      this.rotation = 0;
      this.rotationDirection = 1;
      this.rotationStep = 0.01;
      this.maxRotation = 10;
      this.velocity = 0;

      this.prevScrollY = window.scrollY;
      this.scrollDirection = 0;
      this.prevScrollDirection = 0;
      this.scheduled = false;

      this.isSP = isNarrowView();
      this.setScrollRatio();

      this.mq = window.matchMedia(`(max-width: ${BREAKPOINTS.narrow}px)`);
      this.mq.addEventListener("change", () => {
        this.isSP = isNarrowView();
        this.setScrollRatio();
      });

      this.isInitialAnimating = true;
      this.initialAnimationId = null;

      this.startInitialAnimation();

      document.addEventListener("scroll", () => {
        if (this.isInitialAnimating) {
          // スクロール発生時に初期アニメーションをキャンセル
          cancelAnimationFrame(this.initialAnimationId);
          this.isInitialAnimating = false;
        }

        if (!this.scheduled) {
          this.scheduled = true;
          requestAnimationFrame(() => {
            this.handleScroll();
            this.scheduled = false;
          });
        }
      });
    }

    setScrollRatio() {
      this.scrollRatio = this.isSP ? 0.1 : 0.5;
    }

    startInitialAnimation() {
      const duration = 4000;
      const start = performance.now();

      const animate = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);

        const ease = 1 - Math.pow(1 - progress, 3); // easeOut
        const angle = -this.maxRotation/2 * ease;
        const gapY = 0;

        this.rotation = angle;
        this.applyTransform(gapY, this.rotation);

        if (progress < 1 && this.isInitialAnimating) {
          this.initialAnimationId = requestAnimationFrame(animate);
        } else {
          this.isInitialAnimating = false;
          this.prevScrollY = window.scrollY;
        }
      };

      this.initialAnimationId = requestAnimationFrame(animate);
    }

    handleScroll() {
      if (this.isInitialAnimating) return;

      const currentScrollY = window.scrollY;
      const deltaY = currentScrollY - this.prevScrollY;
      this.scrollDirection = deltaY > 0 ? 1 : deltaY < 0 ? -1 : this.scrollDirection;

      if (this.scrollDirection !== 0 && this.scrollDirection !== this.prevScrollDirection) {
        if (this.scrollDirection === -1) {
          this.rotationDirection *= -1;
        }
        this.prevScrollDirection = this.scrollDirection;
      }

      this.updateRotation();

      const gapY = this.isSP
        ? this.getSPGapY()
        : currentScrollY * this.scrollRatio;

      this.applyTransform(gapY, this.rotation);
      this.prevScrollY = currentScrollY;

      clearTimeout(this.inertiaTimer);
      this.inertiaTimer = setTimeout(() => this.applyInertia(), 10);
    }

    getSPGapY() {
      const rect = this.wrap.getBoundingClientRect();
      const wrapCenterY = rect.top + rect.height / 2;
      const screenCenterY = window.innerHeight / 2;
      const centerDiff = wrapCenterY - screenCenterY;
      return centerDiff * this.scrollRatio;
    }

    updateRotation() {
      this.rotation += this.rotationStep * this.rotationDirection;

      if (this.rotation >= this.maxRotation && this.rotationDirection === 1) {
        this.rotationDirection = -1;
        this.rotation = this.maxRotation;
      } else if (this.rotation <= -this.maxRotation && this.rotationDirection === -1) {
        this.rotationDirection = 1;
        this.rotation = -this.maxRotation;
      }
    }

    applyInertia() {
      const duration = 2000;
      const startRotation = this.rotation;
      const direction = this.rotationDirection;
      const inertiaAmplitude = 2.5;
      const targetRotation = this.rotation + inertiaAmplitude * direction;

    
      const startTime = performance.now();
    
      const animate = (now) => {
        const elapsed = now - startTime;
        const progress = Math.min(elapsed / duration, 1);
    
        // easeOutCubic
        const ease = 1 - Math.pow(1 - progress, 3);
    
        this.rotation =
          startRotation + (targetRotation - startRotation) * ease;
    
        const gapY = this.isSP
          ? this.getSPGapY()
          : window.scrollY * this.scrollRatio;
    
        this.applyTransform(gapY, this.rotation);
    
        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
    
      requestAnimationFrame(animate);
    }
    

    applyTransform(gapY, rotateDeg) {
      const transformValue = `translateY(${gapY}px) rotate(${rotateDeg}deg) translateZ(0)`;
      if (this.img) {
        this.img.style.transform = transformValue;
      } else {
        this.wrap.style.transform = transformValue;
      }
    }
  }

  document.querySelectorAll(".js-symbol").forEach((wrap) => {
    new Symbol(wrap);
  });
})();
